module.exports = __webpack_public_path__ + "img/bratthet.82d0645f.jpg";